<div class="grid">
  <ui-loading [isLoading]="true"></ui-loading>
</div>
